module.exports = __webpack_public_path__ + "static/media/Hospital-Procurement-Experts.67d11c30.jpg";